/**
 * Polyfill for `crypto.randomUUID` in insecure contexts.
 *
 * `crypto.randomUUID()` is only exposed in secure contexts (HTTPS or
 * `localhost`). When the app is served over plain HTTP on a LAN IP — e.g.
 * `http://192.168.x.x:5173` while testing on a phone/tablet — it is `undefined`,
 * and every code path that mints an id (stitches, guides, history snapshots)
 * throws `TypeError: crypto.randomUUID is not a function`.
 *
 * `crypto.getRandomValues()` is NOT gated to secure contexts, so we derive an
 * RFC 4122 v4 UUID from it. Side-effect import; must run before any id is
 * generated (imported first in `src/index.tsx`).
 */
const HEX: string[] = [];
for (let i = 0; i < 256; i++) {
    HEX.push((i + 0x100).toString(16).slice(1));
}

if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
    (crypto as { randomUUID: () => string }).randomUUID =
        function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
            const b = new Uint8Array(16);
            crypto.getRandomValues(b);
            // RFC 4122 §4.4: version 4 in the high nibble of byte 6, variant
            // (10xx) in the high bits of byte 8.
            b[6] = (b[6] & 0x0f) | 0x40;
            b[8] = (b[8] & 0x3f) | 0x80;
            return `${HEX[b[0]]}${HEX[b[1]]}${HEX[b[2]]}${HEX[b[3]]}-${HEX[b[4]]}${HEX[b[5]]}-${HEX[b[6]]}${HEX[b[7]]}-${HEX[b[8]]}${HEX[b[9]]}-${HEX[b[10]]}${HEX[b[11]]}${HEX[b[12]]}${HEX[b[13]]}${HEX[b[14]]}${HEX[b[15]]}`;
        };
}
